import { createServerFn } from "@tanstack/react-start";
import { getPublishedWisdom, listPublishedWisdom, relatedWisdom } from "@/lib/wisdom.server";
import type { PublicWisdomPost } from "@/lib/wisdom-kinds";

export type { PublicWisdomPost, ArticleKind } from "@/lib/wisdom-kinds";

export const getWisdomIndex = createServerFn({ method: "GET" }).handler(
  async (): Promise<PublicWisdomPost[]> => listPublishedWisdom(),
);

export const getWisdomPost = createServerFn({ method: "GET" })
  .inputValidator((d: { slug: string }) => ({ slug: String(d?.slug ?? "").slice(0, 120) }))
  .handler(async ({ data }): Promise<{ post: PublicWisdomPost; related: PublicWisdomPost[] } | null> => {
    const post = await getPublishedWisdom(data.slug);
    if (!post) return null;
    return { post, related: await relatedWisdom(post, 3) };
  });
